import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiOrderDetailComponent } from './ui-order-detail.component';

@NgModule({
  declarations: [UiOrderDetailComponent],
  imports: [CommonModule],
  exports: [UiOrderDetailComponent],
})
export class OrderDetailModule {}
